export interface AppConfig {
  logtoEndpoint: string;
  logtoAppId: string;
  apiBase: string;
  apiResource: string;
}

declare global {
  interface Window {
    __DESKTOUCH_CONFIG__?: Partial<AppConfig>;
  }
}

/**
 * Runtime configuration.
 *
 * The nginx container writes `/config.js` on startup, populating
 * `window.__DESKTOUCH_CONFIG__` with the four values below. When the file is
 * missing (local dev with `vite dev`, or a bundle opened directly) the local
 * defaults keep the app functional against a docker compose dev stack.
 */
const runtime = window.__DESKTOUCH_CONFIG__ ?? {};

export const config: AppConfig = {
  logtoEndpoint: runtime.logtoEndpoint ?? 'http://localhost:3001',
  logtoAppId: runtime.logtoAppId ?? '',
  apiBase: runtime.apiBase ?? 'http://localhost:3000',
  apiResource: runtime.apiResource ?? 'http://localhost:3000',
};

export const ADMIN_SCOPE = 'desktouch:admin';
